import type { NicheSlug } from '@maintenance-tracker/shared';
import { NICHE_TO_TRADE_TYPE, getDefaultPlanNameForNiche } from '@maintenance-tracker/shared';

const STORAGE_KEY = 'renewaldrive_signup_niche';

export function persistSignupNiche(niche: string | null): void {
  if (!niche) return;
  if (!(niche in NICHE_TO_TRADE_TYPE)) return;
  sessionStorage.setItem(STORAGE_KEY, niche);
}

export function readSignupNiche(): NicheSlug | null {
  const v = sessionStorage.getItem(STORAGE_KEY);
  if (v && v in NICHE_TO_TRADE_TYPE) return v as NicheSlug;
  return null;
}

export function clearSignupNiche(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function nicheToTradeType(niche: NicheSlug): (typeof NICHE_TO_TRADE_TYPE)[NicheSlug] {
  return NICHE_TO_TRADE_TYPE[niche];
}

export function signupUrlForNiche(niche: NicheSlug): string {
  return `/signup?niche=${niche}`;
}

export function signupSearchForNiche(niche: NicheSlug): { niche: NicheSlug } {
  return { niche };
}

export function getOnboardingDefaultsFromNiche(niche: NicheSlug | null) {
  if (!niche) return null;
  const tradeType = nicheToTradeType(niche);
  return {
    trade_type: tradeType,
    plan_name: getDefaultPlanNameForNiche(niche),
  };
}

export function captureNicheFromSearchParams(): NicheSlug | null {
  const params = new URLSearchParams(window.location.search);
  const niche = params.get('niche');
  if (niche && niche in NICHE_TO_TRADE_TYPE) {
    persistSignupNiche(niche);
    return niche as NicheSlug;
  }
  return readSignupNiche();
}
